export const CATEGORY_START = "CATEGORY_START";
export const CATEGORY_SUCCESS = "CATEGORY_SUCCESS";
export const CATEGORY_FAIL = "CATEGORY_FAIL";

export const PRODUCT_START = "PRODUCT_START";
export const PRODUCT_SUCCESS = "PRODUCT_SUCCESS";
export const PRODUCT_FAIL = "PRODUCT_FAIL";
export const PRODUCT_SETIMAGE_START = "PRODUCT_SETIMAGE_START";
export const PRODUCT_SETIMAGE_SUCCESS = "PRODUCT_SETIMAGE_SUCCESS";
export const PRODUCT_SETIMAGE_FAIL = "PRODUCT_SETIMAGE_FAIL";

export const CONTACTUS_START = "CONTACTUS_START";
export const CONTACTUS_SUCCESS = "CONTACTUS_SUCCESS";
export const CONTACTUS_FAIL = "CONTACTUS_FAIL";

export const LOGIN_START = "LOGIN_START";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";

export const LOGOUT = "LOGOUT";

export const SIGNUP_START = "SIGNUP_START";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_FAIL = "SIGNUP_FAIL";

export const CART_FETCH_START = "CART_FETCH_START";
export const CART_FETCH_SUCCESS = "CART_FETCH_SUCCESS";
export const CART_FETCH_FAIL = "CART_FETCH_FAIL";
